module.exports = __webpack_public_path__ + "static/media/options.8c108a9e.svg";